"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _CustomLegend = require("../../shared/recharts/CustomLegend");
var _CustomTooltip = _interopRequireDefault(require("../../shared/recharts/CustomTooltip"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SimpleLineChart = ({
  height = '350px',
  width = '100%',
  data = [],
  lines,
  xAxisDataKey,
  yAxisDataKey,
  xAxisLine = false,
  yAxisLine = false,
  tickLineX = false,
  tickLineY = false,
  allowDecimalsInTooltip = true,
  legendHAlign = 'left',
  legendVAlign = 'bottom',
  margin,
  legendPadding,
  xAxisPadding = {
    left: 50,
    right: 50
  },
  layout = 'horizontal',
  tickFormatterX = e => e,
  tickFormatterY = e => e,
  tooltipFormatter = e => e,
  ...rest
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LineChartContainer, {
    height: height,
    width: width,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.LineChart, {
        data: data,
        margin: margin && margin,
        barGap: "0%",
        layout: layout && layout,
        ...rest,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
          strokeDasharray: "0",
          vertical: false
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, {
          dataKey: xAxisDataKey && xAxisDataKey,
          axisLine: xAxisLine && xAxisLine,
          tickLine: tickLineX && tickLineX,
          type: layout === 'vertical' ? 'number' : 'category',
          padding: xAxisPadding && xAxisPadding,
          tickFormatter: tickFormatterX,
          tickMargin: 5
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, {
          dataKey: yAxisDataKey && yAxisDataKey,
          axisLine: yAxisLine && yAxisLine,
          tickLine: tickLineY && tickLineY,
          type: layout === 'vertical' ? 'category' : 'number',
          tickFormatter: tickFormatterY
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomTooltip.default, {
            formatter: tooltipFormatter,
            lineConfig: lines,
            allowDecimals: allowDecimalsInTooltip
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Legend, {
          verticalAlign: legendVAlign && legendVAlign,
          align: legendHAlign && legendHAlign,
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomLegend.CustomLegend, {}),
          wrapperStyle: {
            paddingLeft: legendPadding?.left ? legendPadding.left : '50px',
            paddingTop: legendPadding?.top ? legendPadding.top : '10px',
            paddingBottom: legendPadding?.bottom ? legendPadding.bottom : '0',
            paddingRight: legendPadding?.right ? legendPadding.right : '0'
          }
        }), lines?.length && lines.map(line => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Line, {
            type: line.type,
            dataKey: line.dataKey,
            stroke: line.stroke,
            strokeWidth: line.strokeWidth,
            name: line.name
          }, line.name);
        })]
      })
    })
  });
};
var _default = exports.default = SimpleLineChart;